import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { getImage } from '../data/images';
import { Reveal } from './Reveal';
const AMENITIES = [{
  en: 'Resort-style swimming pool',
  es: 'Piscina estilo resort'
}, {
  en: 'Water park',
  es: 'Parque acuático'
}, {
  en: 'Mini golf',
  es: 'Minigolf'
}, {
  en: 'Fitness center',
  es: 'Gimnasio'
}, {
  en: 'Arcade',
  es: 'Arcade'
}, {
  en: 'Volleyball court',
  es: 'Cancha de voleibol'
}, {
  en: 'Restaurant',
  es: 'Restaurante'
}, {
  en: 'Coffee shop',
  es: 'Cafetería'
}];
export function AmenitiesSection() {
  const {
    lang,
    t
  } = useLanguage();
  const pool = getImage('resortPool');
  const gym = getImage('fitnessCenter');
  const waterPark = getImage('waterPark');
  return <section id="amenities" className="w-full bg-midnight" data-id="element-50" data-mp="2yjjgw4wlyh5h">
      <div className="relative isolate w-full overflow-hidden" data-id="element-51" data-mp="itgmome2bdvm">
        {pool && <img src={pool.src} alt={lang === 'en' ? pool.altEn : pool.altEs} width={pool.width} height={pool.height} loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover" style={{
        objectPosition: pool.objectPosition
      }} data-id="element-52" data-mp="dv5e0ezi79ez" />}
        <div aria-hidden="true" className="absolute inset-0 bg-midnight/55" data-id="element-53" data-mp="2z4ti6yryuekg" />
        <div className="relative mx-auto max-w-editorial px-5 py-24 lg:px-8 lg:py-40" data-id="element-54" data-mp="337zou7izq7rg">
          <Reveal data-id="element-55" data-mp="26jjvs1go9g9l">
            <div className="max-w-2xl bg-midnight/55 p-6 backdrop-blur-[2px] lg:bg-transparent lg:p-0 lg:backdrop-blur-none" data-id="element-56" data-mp="26k3ehke5c8oo">
              <p className="label-caps text-gold" data-id="element-57" data-mp="2fiym90wu9qu3">
                {t('More Than a Home', 'Mucho Más que una Casa')}
              </p>
              <h2 className="mt-5 font-display text-[34px] font-semibold uppercase leading-[1.02] text-white sm:text-[46px] lg:text-[56px]" data-id="element-58" data-mp="2k9x8eh4idj59">
                {t('Every Day Feels Like a Resort', 'Cada Día Se Siente Como un Resort')}
              </h2>
              <p className="mt-6 max-w-xl text-[15px] leading-relaxed text-white/85 lg:text-base" data-id="element-59" data-mp="1rqzwxd0k1uxy">
                {t('Enjoy a resort-style community offering recreation, entertainment, fitness and convenient dining options.', 'Disfruta de una comunidad estilo resort con opciones de recreación, entretenimiento, ejercicio y lugares para comer.')}
              </p>
            </div>
          </Reveal>
        </div>
      </div>

      <div className="mx-auto max-w-editorial px-5 pb-24 lg:px-8 lg:pb-32" data-id="element-60" data-mp="2c5nzz5i5e0hm">
        <div className="grid gap-8 lg:grid-cols-12 lg:gap-12" data-id="element-61" data-mp="277mgwkkq2165">
          <div className="grid gap-6 sm:grid-cols-2 lg:col-span-7" data-id="element-62" data-mp="2l5uaqjmgomd3">
            {gym && <Reveal data-id="element-63" data-mp="2h4ij68k11r29">
                <figure className="lg:-mt-16" data-id="element-64" data-mp="2h48z11lnye4h">
                  <div className="h-[220px] w-full overflow-hidden border border-white/10 sm:h-[300px]" data-id="element-65" data-mp="2h6lffabrwgff">
                    <img src={gym.src} alt={lang === 'en' ? gym.altEn : gym.altEs} width={gym.width} height={gym.height} loading="lazy" decoding="async" className="h-full w-full object-cover" style={{
                  objectPosition: gym.objectPosition
                }} data-id="element-66" data-mp="hpq1v45uhhq" />
                  </div>
                  <figcaption className="label-caps mt-4 text-white/60" data-id="element-67" data-mp="3v4vbsjrbtmyx">
                    {t('Fitness Center', 'Gimnasio')}
                  </figcaption>
                </figure>
              </Reveal>}
            {waterPark && <Reveal delay={0.06} data-id="element-68" data-mp="rp7uc65lh09z">
                <figure className="lg:mt-6" data-id="element-69" data-mp="cz8ulyye5gse">
                  <div className="h-[220px] w-full overflow-hidden border border-white/10 sm:h-[300px]" data-id="element-70" data-mp="cwe9s6bgttyg">
                    <img src={waterPark.src} alt={lang === 'en' ? waterPark.altEn : waterPark.altEs} width={waterPark.width} height={waterPark.height} loading="lazy" decoding="async" className="h-full w-full object-cover" style={{
                  objectPosition: waterPark.objectPosition
                }} data-id="element-71" data-mp="hv7eb98ryamh" />
                  </div>
                  <figcaption className="label-caps mt-4 text-white/60" data-id="element-72" data-mp="38yuaniskciwr">
                    {t('Water Park', 'Parque Acuático')}
                  </figcaption>
                </figure>
              </Reveal>}
          </div>

          <Reveal className="lg:col-span-5 lg:pt-6" delay={0.08} data-id="element-73" data-mp="gelt23ionwf">
            <ul className="divide-y divide-white/10 border-y border-white/10" data-id="element-74" data-mp="jaikn3mp6ja">
              {AMENITIES.map(amenity => <li key={amenity.en} className="flex items-center gap-4 py-4 text-[14px] text-white/85" data-id="element-75" data-mp="3mx2bw2wmu6dq">
                  <span aria-hidden="true" className="h-px w-6 shrink-0 bg-gold" data-id="element-76" data-mp="o8ln8fo3nl2p" />
                  {lang === 'en' ? amenity.en : amenity.es}
                </li>)}
            </ul>
            <p className="mt-6 text-[12px] leading-relaxed text-white/55" data-id="element-77" data-mp="rq9bk09x3z6h">
              {t('Community amenity access, hours, availability and any associated fees are set by the community and must be independently verified by the buyer.', 'El acceso a las amenidades de la comunidad, los horarios, la disponibilidad y cualquier costo asociado son establecidos por la comunidad y deben ser verificados independientemente por el comprador.')}
            </p>
          </Reveal>
        </div>
      </div>
    </section>;
}